$(document).ready(function() {
  btnDisabled()
  btnEnabled()
  loopingMfQualificationIds()
  conditionRemoveField()

  $('.add_fields').click(function() {
    var timeout = null;

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      enableSubmitForm()
      conditionRemoveField()
    }, 100);
  })

  function conditionRemoveField() {
    $('.remove_fields').click(function() {
      var timeout = null;
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        btnDisabled()
      }, 100);
    })
  }

  function disabledSubmitForm(major_id) {
    $(`.remove_field_mf_qualification_${major_id}`).click(function() {
      var timeout = null;

      var mf_qualification = $(this).parents('.nested-fields').find('.mf_qualification_id')
      var condition1 = mf_qualification.length == 0

      if (!condition1) {
        var data_confirm = confirm(I18n.t('global.notices.delete_permanently'))
        if (!data_confirm) {
          return data_confirm
        }

        var incentive_trip_id = mf_qualification.data('incentive-trip-id')
        var incentive_qualification_id = mf_qualification.data('incentive-qualification-id')
        var mf_qualification_id = mf_qualification.data('mf-qualification-id')
        deleteMajorFunctionQualification(incentive_trip_id, incentive_qualification_id, mf_qualification_id)
      }

      clearTimeout(timeout);

      timeout = setTimeout(() => {
        btnDisabled()
      }, 100);
    })
  }

  function btnDisabled() {
    var length_nested = $('div[class="nested-fields"]').length
    if (length_nested <= 0) {
      $('.btn-mf-qualifications').attr('disabled', true)
      $('.error_message_mf_qualifications').removeClass('d-none')
    }
  }

  function enableSubmitForm() {
    var timeout = null;
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      btnEnabled()
    }, 100);
  }

  function btnEnabled() {
    var length_nested = $('div[class="nested-fields"]').length
    if (length_nested > 0) {
      $('.btn-mf-qualifications').removeAttr('disabled')
      $('.error_message_mf_qualifications').addClass('d-none')
    }
  }

  function deleteMajorFunctionQualification(incentive_trip_id, incentive_qualification_id, mf_qualification_id) {
    $.ajax({
      type: "DELETE",
      dataType:"json",
      data: { 'incentive_trip_id' : incentive_trip_id, 'incentive_qualification_id' : incentive_qualification_id,
              'mf_qualification_id' : mf_qualification_id },
      url: `/admin/incentive_trips/${incentive_trip_id}/incentive_qualifications/${incentive_qualification_id}/destroy_major_function_qualification/${mf_qualification_id}`,
      success: function(response){
        if (response['message'] = 'success') {
          var mf_id = response['mf_id']
          $(`#mf_qualification_id_${mf_id}`).parent().remove()
          $.each($('input[type=hidden]'), function( index, value ) {
            if (value.value == mf_id) {
              value.remove()
            }
          });
        }
        btnDisabled()
      }
    });
  }

  function loopingMfQualificationIds() {
    var mf_qualification_ids = $('.mf_qualification_id')
    var length_mf_qualification = mf_qualification_ids.length == 0
    if (!length_mf_qualification) {
      $.each(mf_qualification_ids, function( index, value ) {
        var major_id = value.dataset['mfQualificationId']
        disabledSubmitForm(major_id)
      });
    }
  }
});